var React = require('react');

function IconArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 5L7 0L6.295 0.705L10.085 4.5L0 4.5L0 5.5L10.085 5.5L6.295 9.295L7 10L12 5Z","fill":"white"}));
}

IconArrow.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"};

module.exports = IconArrow;

IconArrow.default = IconArrow;
